import { PunchCardsForAllDrivers } from '../../../models';
import { getPunchCardsForDriver } from './getPunchCardsForDriver';
import { getUserJSON } from './getUser';

export const getPunchCardSummary = (data: any): PunchCardsForAllDrivers => {
  const driver = getUserJSON(data.driver);
  driver.id = data.user_id || "";

  return {
    driver,
    summary: getPunchCardsForDriver(data.summary)
  };
}

export const getPunchCardSummaries = (data: any): PunchCardsForAllDrivers[] => {
  return data.map(getPunchCardSummary);
}
